import { render, staticRenderFns } from "./svgGroup.vue?vue&type=template&id=20d5e037&scoped=true&"
import script from "./svgGroup.vue?vue&type=script&lang=js&"
export * from "./svgGroup.vue?vue&type=script&lang=js&"
import style0 from "./svgGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./svgGroup.vue?vue&type=style&index=1&id=20d5e037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5e037",
  null
  
)

export default component.exports